// extracted by mini-css-extract-plugin
export var progressBar = "_fa-0";
export var progressBarInner = "_fa-1";